<template>
  <div :class="{
          'is-right': message.name === 'self',
          'is-left': message.name !== 'self',
          'is-danger': message.status === 'error',
          'is-fullscreen': fullscreen}"
       class="chat-message"
       :id="'chat-message-' + message.innerId">
    <div v-if="message.name !== 'self'"
         class="user-head float-up">
      <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAACjlBMVEUAAAC4t7fu7e1aWlrWysPo4t7x7+8FBQUCAgLf39/Y2NjT0M8dHR3b2djs7Ozs6ef5+fnGwr8yMjKXl5c4ODgtLS3Puq7Hxsa7sKrEw8LY19cLCwsCAgIZGRnW1tbZ2NgBAQERERHGxsYAAAAXFxfQzcsgICDo6Ojc3NweHh7U1NTV1NSOjo7Ew8PS0tLm5ubOy8l0dHSkpKQ4ODjX0c3Jv7hISEgEBATT0tI6OjpPT0/CtrDd3d0FBQX09PR4eHhJSUnh4eHk18/6+vn6+fn+3cr828j+1L4CAQH49/f81L7c29vQtabk4+MAAADz8vLu7e3e3d3a2tri4eHh4ODHx8cJCAfp6Ojw6ufm5eXX1dX318X40Lu7u7vUuaqhjYIFBQT19PTw7ezj4uLY19fQz89b38pY3slU3sjbzsfExMS+vb370rzpyrnfw7Pbv6/YvKzOtKWnpaRsXldTSEIPDg4NCwrr6urq5uR65NNj4MzMy8vLysq+xsTz1MLx0sHBwcHrzbwh1bjtyLTyyrPxyLDXva/XuKjKtKjBsKbVtaPJrp++qp62p56xnZKslIankYSlj4OShHxfUkpVQTUyMC8sIRvw+Pbn7ezv6OXv6OTn4t/l3dl149Jx4tB84dBp4c5g38tP3MZF28P72MP61sLr0ME72cBP078z2L6/vr7ky7zVxbwp1rv2zrfjx7fjxrZUyLXUwLW+uLS1tLSzs7PFtqyzrargvKnuwajduqi1q6bZt6XNsaHBraDJrJ3Dqpubm5u9pZe4opWqmZC7nY2dkouslom0l4iVh4GrjXuSf3SihHJ3bWZpZGFzZFt+ZFVYT0lXQzhGNiw+MCc3KiMnIiAzJh8hGBQYExB1nHwwAAAARHRSTlMAAxYcFw7+8uTWp4N5VEc3JB0ZEgsF/Pj39fPu28zLyMTDwsG8trCum4mGe3FraWZjXlxMSkpIRUFANSkmJRwaEgoIBzexzlIAAAJ0SURBVDjLvc9jl+NQGMDxtGPteG3bNnLvJE2bcmuNjXbajm171rZt2/a32SbFmT27N91X83/15Dm/8yTBhiUe77+Y35zpE2bG+LK8mHFmQml3KIPCN3G5uA3jCZo22+1KggiPRbvNq6bRNOEueBnSxcZPpgnlz8EfX798G1TSU3jI3wgmfn3++LahHoDzt/odQUi4ljb36SBw1dBvjkfBNcRAHvD2+nscCq50vIMe1gMqP/mh4JKBZpPNVvgQAOELU1dB73wUXPq+AAJv8MwCFIx8nguFfd2MKvwA4HETCvp31kCLzcTCNwBe6IlGwIDHeUNfnfcEQ7TVYjma4yRGxgn0xqcYqpb7xxgjBEy69uUYMv+LwFtlB8YBR0IvrLqBcbQiH4I2oVAIoK4d4+x6DQSMg43RGHctuRA4ndGK+ar3XpUut/uVT8fvFLzseqbPX8zNtvGv3BQkJCQI6pojOBgvIKzjttMx1bet4wVE/UtFzQopv/NAzzrmZk7T6BkRW/5iG2fLUhWaPZmNdTkCNn1+ZrFYO2bSoj/d+lCNitKKyMDizMvG1rutTQVn9ybhqhSxSjpxxBC3MERCkjguk4lIcZJard69S51ESuQpOE6Ki+bxvS5M41RslFSqYAeRXCGl2IkMDPXc5I91O1aIpDKKksqT5d5VYnmkC1Ynelba1ERSonEOO9IPZ5SmpbnX4u0umKXwwOqrqVmPrFkGQ8XJtNqMcxkl7g9ywblFlAdaywzZ2aezrxkqLp04daQ2/RC7lZMqGQOnkrhHSsRlyZQkWSHZeSC9tOTgvv3sVobj7MlRJK7FORLhbriaZB7QpbDwNzev+bwnDijWAAAAAElFTkSuQmCC"/>
    </div>
    <div :class="{'zoom-in': zoomIn}"
         class="message-content-wrapper">
      <div class="message-content"
           :class="{'is-active': isActive}"
           :style="contentStyle">
        <span v-if="fullWidth" class="full-width"></span>
        <slot></slot>
        <span v-if="repeats"
              :id="'message-repeats-' + _uid"
              class="repeats">×{{ message.repeats }}</span>
      </div>
      <slot name="bottom-commands"></slot>
    </div>
    <div v-if="message.name === 'self'"
         class="user-head">
      <img alt="" :src="$imagePath(IClassroom.user.head_image)" width="36">
    </div>
  </div>
</template>

<script>
import { MessageType } from '../lib/Message'
import IClassroom from '@/components/classroom/lib/IClassroom'

const IDE = window['IDE']

export default {
  props: {
    'message': {},
    'left': { default: true },
    'fullWidth': { default: false },
    'isActive': { default: false },
    'fullscreen': { default: false }
  },
  data () {
    return {
      MessageType: MessageType,
      zoomIn: true,
      IClassroom
    }
  },
  mounted () {
    this.message.offsetTop = this.$el.offsetTop
    this.message.estHeight = this.$el.offsetHeight

    IClassroom.messageWindowHeight = Math.max(IClassroom.messageWindowHeight, this.message.offsetTop + this.message.estHeight)
    IClassroom.messageWindowWidth = document.getElementById('message-window').offsetWidth
  },
  computed: {
    repeats () {
      const r = this.message.repeats > 1
      if (r) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.zoomIn = false
        // eslint-disable-next-line vue/no-async-in-computed-properties
        setTimeout(() => {
          this.zoomIn = true
        }, 10)
      }
      return r
    },
    contentStyle () {
      if (this.fullscreen) {
        let left = Math.max(0, (IDE.layout.mainWidth - 1366) / 2)
        return {
          position: 'fixed',
          overflowY: 'auto',
          transition: 'left .6s',
          padding: '1rem',
          borderRadius: '0',
          zIndex: 999,
          top: IDE.layout.topnavHeight + 'px',
          left: left + (IDE.layout.showNav ? IDE.layout.leftNavWidth : 0) + 'px',
          bottom: '0',
          width: IDE.layout.mainWidth - left * 2 - 250 + 'px'
        }
      }
      return ''
    }
  }
}
</script>

<style lang="stylus" scoped>
$r = 5px

.chat-message-anchor {
  position absolute
  bottom -6rem
}

.chat-message {
  display flex
  position relative
  margin-bottom 2rem
}

.user-head-svg {
  fill $cardColor
}

.user-head {
  width 40px
  height 40px
  overflow hidden
  display flex
  align-items center
  justify-content center
  user-select none
  border-radius 50%
  background white
  border 2px solid white
}

.repeats {
  position absolute
  right -3px;
  bottom: 27px;
  border-radius 4px
  display block
  padding 2px 3px
  background rgb(252, 211, 59)
  color $cardBackground
  line-height 1
  font-size 14px
  transform translateX(100%)
}

.message-content-wrapper {
  position relative
  max-width calc(100% - 50px)
  min-width 50px
  flex-grow 0
  margin-left 10px
}

.message-content {
  width 100%
  background $cardBackground
  color $defaultColor
  position relative

  &.is-active {
    animation focus-wave 1s ease-in-out infinite
  }

  &:after {
    content ''
    position absolute
    top 14px
    width: 0;
    height: 0;
    border-style: solid;
  }
}

.full-width {
  width 100vw
  display block
}

.chat-message {
  .repeats {
    right auto
    left -3px
    bottom: 27px;
    transform translateX(-100%)
  }

  .message-content-wrapper {
    margin-left 10px
    transform-origin 0 100%
  }

  .message-content {
    border-radius $r


    &:after {
      left -6px
      border-width: 6px 6px 6px 0;
      border-color: transparent $cardBackground transparent transparent;
    }
  }
}

.chat-message.is-danger {
  .message-content {
    font-weight bold
    color $errorForeground
  }
}

.chat-message.is-right {
  .message-content-wrapper {
    margin-right 10px
    margin-left auto
    transform-origin 100% 100%
  }

  .message-content {
    background #3273dc
    color $cardBackground

    &:after {
      left auto
      right -6px
      border-width: 6px 0 6px 6px;
      border-color: transparent transparent transparent #3273dc;
    }
  }
}

@keyframes zoomIn {
  from {
    transform: scale(.9);
  }
  to {
    transform: scale(1);
  }
}

@keyframes floatUp {
  from {
    transform: translateY(5px) rotate(5deg);
  }
  to {
    transform: translateY(0) rotate(0);
  }
}

.zoom-in {
  animation: zoomIn .3s ease-out;
}

.float-up {
  transform-origin 50% 50%
  animation: floatUp .3s ease-out;
}
</style>
